// ... other imports ...

import styled from 'styled-components';
import React,{ useState } from 'react';
import Pic from 'assets/images/lock.png'
import {words} from '../translations'

const Screen2 = ({language,ai_disclaimer}) =>{

    return (
        <Container>
             <Emoji src={Pic}/>

             {ai_disclaimer?<Disclaimer>
                {words['intro4-2'][language]}
             </Disclaimer>:""}
             <Text>
           {words['intro4-0'][language]}
            </Text>

            <Linked href="https://innerlogic.com/privacy" target="_blank">{words['intro4-1'][language]}</Linked>
        </Container>
       
    )
}

export default Screen2

const Text = styled.div`
font-weight: 500;
font-size: 20px;
line-height: 1.6;
color: #2A3039;
margin-bottom:24px;
`

const Container = styled.div`
    font-family: 'Raleway', sans-serif;
`

const Linked = styled.a`
    text-decoration: underline;
    font-weight: 500;
    font-size: 16px;
    line-height: 128%;
    color: #2D70E2;
`

const Emoji = styled.img`
    height:40px;
    margin-bottom: 40px;
`

const Disclaimer = styled.div`
    font-size:20px;
    font-weight: 500;
    margin-bottom:20px;
    line-height: 1.4;
`